import { FunctionComponent, useEffect } from "react";
import { DashboardModel, useDashboardTheme } from "@sisense/sdk-ui";

export interface GetWidgetModelProps {
  dashboardModel: DashboardModel;
  exitComponent: (dashboardTheme?: any) => void;
}

export const GetDashboardModel: FunctionComponent<GetWidgetModelProps> = ({
  dashboardModel,
  exitComponent,
}) => {
  const { themeSettings: dashboardTheme } = useDashboardTheme({
    styleOptions: dashboardModel?.styleOptions,
  });

  useEffect(() => {
    if (dashboardTheme) {
      exitComponent(dashboardTheme);
    }
  }, [dashboardTheme, exitComponent]);

  return null;
};
